<template>
  <!-- 値は1つのみの選択なので、結果は配列にならない -->

  <div>
    <div v-if="caption" class="text-xs font-bold text-gray-600 mb-1">{{ caption }}<span v-if="required" class="ml-1 text-red-500"> * </span></div>

    <div class="w-full flex flex-wrap gap-0.5 text-sm" :class="disabled?'cursor-not-allowed':''">

      <Icon v-if="required&&(!value&&value!==0)" iconName="ExclamationCircle" class="h-5 w-5 text-red-400 self-center" />

      <div v-for="(v, i) in list" :key="i"
        class="flex-1 py-1.5 text-center border cursor-pointer rounded-sm"
        :class="[value === v.id?'bg-indigo-900 border-indigo-900 text-white font-bold':'border-gray-300 text-gray-700 bg-white']"
        @click="select(v)"
      >
        {{ v.name }}
      </div>
    </div>
  </div>

  </template>
  <script>
  import Icon from '@components/Icon.vue'

  export default {

    components: {
      Icon
    },

    model: {
      prop: 'value',
      event: 'change'
    },

    props: {
      value: {
        type: [String, Number, null],
        default: null
      },
      list: {
        type: Array,
        default: () => []
      },
      caption: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
    },

    methods: {
      select(v) {
        if (this.disabled) {
          return
        }

        // 同じものを再選択
        if (this.value == v.id) {
          this.$emit('change', null)
          this.$emit('select', { id: null, name: null })
        } else {
          this.$emit('change', v.id)
          this.$emit('select', v)
        }
      }
    }
  }
  </script>